import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import WhatIsSection from './components/WhatIsSection';
import FeaturesSection from './components/FeaturesSection';
import ArticlesSection from './components/ArticlesSection';
import ReviewSection from './components/ReviewSection';
import ShippingSection from './components/ShippingSection';
import DiscountSection from './components/DiscountSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL;

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Sugargoo Spreadsheet',
            url: siteUrl,
            description:
              'Discover the ultimate Sugargoo Spreadsheet with verified finds, product comparisons, QC photos, shipping guides, discount codes, and expert shopping tips for international buyers.',
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: siteUrl + '/?s={search_term_string}',
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Sugargoo Spreadsheet',
            url: siteUrl,
            logo: siteUrl + '/favicon.ico',
            description:
              'An independent educational resource providing curated product research, shopping guides, and community-verified finds for international shoppers.',
            sameAs: ['https://kaspreadsheet.com'],
          }),
        }}
      />
      <main>
      <Navbar />
      <HeroSection />
      <CategorySection />
      <WhatIsSection />
      <FeaturesSection />
      <ArticlesSection />
      <ReviewSection />
      <ShippingSection />
      <DiscountSection />
      <CTASection />
      <Footer />
    </main>
    </>
  );
}